/**
 * Названия сесионных кук
 */

module.exports = {
    REMINDER: 'session_reminder',
    'WANNA-SEE': 'session_favorite-program',
};
